let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gCN93")).then(() => parcelRequire('e7OtZ'));